<div class="logo-container" *ngIf="initialLoad || loadingUserLogout">
	<img class="img" src="/assets/img/dropbox-sign-plus-procore.jpg" />
</div>

<div class="loading-message-container" *ngIf="loadingSubmit">
	<span *ngIf="!useGeneratedFile">Uploading file...</span>
	<span *ngIf="useGeneratedFile">The file is generating...</span>
	<div *ngIf="useGeneratedFile">Continue waiting, <a (click)="submitCancel()">cancel the request</a>, or <a (click)="twoZeroFourRetries = 0; submit()">retry the request</a>.</div>
</div>

<div class="loading-container" *ngIf="loading || loadingUserLogout">
	<div class="lds-facebook">
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>

<!-- TRIAL HEADER MESSAGE -->
<div *ngIf="!loading && !loadingUserLogout && !errorResponse" class="header-container">
	<div class="logo-container">
		<i *ngIf="contextService.clientDetailProcore.dropboxSignAccountType == 'OAUTH' || contextService.procoreUserInfo.isAdmin" class="fas fa-bars re-init-icon" (click)="showMenuExpanded = !showMenuExpanded"></i>
		<i class="fas fa-sync-alt re-init-icon" (click)="reInit()" title="Refresh side-panel"></i>
		<div class="flex-container">
			<div class="icon-container">
				<img *ngIf="!contextService.clientDetailProcore.isTrial" src="/assets/img/dropbox-sign-logo.png" title="Dropbox Sign + Procore" />
				<img *ngIf="contextService.clientDetailProcore.isTrial" src="/assets/img/dropbox-sign-logo-trial.png" title="Dropbox Sign + Procore Trial" />
			</div>
			<div class="message-container">
				<div class="sub" *ngIf="contextService.signatureCount.dropboxSignUsername">{{ contextService.signatureCount.dropboxSignUsername }}</div>
				<div class="sub" *ngIf="contextService.signatureCount.signatures">USED {{ contextService.signatureCount.signatures.used || 0 }} / {{ contextService.signatureCount.signatures.total || 0 }} SIGNATURES <i [tooltip]="daysRemainingTemplate" class="fas fa-info" [ngClass]="{'unpaid': !contextService.signatureCount.lastInvoicePaid}" placement="bottom"></i></div>
				<div class="sub" *ngIf="!contextService.signatureCount.signatures"><a href="https://procore-dbs.shakeit.ai/docs/setup-guide/configure-dropbox-sign#signatures-count" target="_blank"><i class="fas fa-external-link-alt"></i> VIEW YOUR USED SIGNATURES COUNT</a></div>
				<ng-template #daysRemainingTemplate>
					<div *ngIf="!contextService.signatureCount.lastInvoicePaid">YOU HAVE AN UNPAID INVOICE</div>
					<div *ngIf="contextService.clientDetailProcore.isTrial">{{ currentTermDaysRemaining }} DAYS UNTIL TRIAL ENDS</div>
					<div *ngIf="!contextService.clientDetailProcore.isTrial">{{ currentTermDaysRemaining }} DAYS UNTIL RENEWAL</div>
				</ng-template>
				<!-- <div class="sub" *ngIf="currentTermDaysRemaining > 30">TERM END DATE: {{ contextService.signatureCount.currentTermEndDate | date:'longDate' }}</div>
				<div class="sub" *ngIf="currentTermDaysRemaining <= 30">DAYS REMAINING: {{ currentTermDaysRemaining }} </div> -->
			</div>
		</div>
	</div>
	<div class="dropdown-container" *ngIf="showMenuExpanded">
		<div class="action" (click)="openUserGuide()"><span> Open User Guide</span> <i class="fas fa-question"></i></div>
		<div class="action" *ngIf="contextService.procoreUserInfo.isAdmin" (click)="showConfigureForm()"><span> Configure Side-panel</span> <i class="fas fa-cog"></i></div>
		<div class="action" (click)="showConfigureUserForm()"><span> Configure User Settings</span> <i class="fas fa-user-cog"></i></div>
		<div class="action" *ngIf="contextService.procoreUserInfo.isAdmin && contextService.signatureCount.stripeCustomerExists && !contextService.clientDetailProcore.isTrial" (click)="launchBillingPortal()"><span>Launch Billing Portal</span> <i *ngIf="loadingLaunchBillingPortal" class="fas fa-spinner fa-spin"></i><i *ngIf="!loadingLaunchBillingPortal" class="far fa-credit-card"></i></div>
		<div class="action" *ngIf="contextService.procoreUserInfo.isAdmin" (click)="launchSignaturesDashboard()"><span>Launch Signatures Dashboard</span> <i *ngIf="loadingLaunchDashboard" class="fas fa-spinner fa-spin"></i><i *ngIf="!loadingLaunchDashboard" class="fas fa-signature"></i></div>
		<div class="action" *ngIf="contextService.clientDetailProcore.dropboxSignAccountType == 'OAUTH' || (contextService.clientDetailProcore.dropboxSignAccountType == 'OAUTHG' && contextService.procoreUserInfo.isAdmin)" (click)="logoutUser()"><span>Unlink Dropbox Sign Account</span> <i class="fas fa-sign-out-alt"></i></div>
	</div>
</div>

<div class="form-container" [ngClass]="{'hidden': loading || loadingUserLogout || showConfigure || showConfigureUser}">
	<form novalidate [formGroup]="form">
		<!-- STATUS HEADER MESSAGE -->
		<app-message *ngIf="signatures.length > 0 && !requestSent && !errorResponse" [signatureObject]="signatures[0]" [expanded]="true" [readonly]="false" (emitRequestCancelled)="requestCancelled($event)"></app-message>
		<ng-container *ngIf="showAllRequests && !requestSent">
			<ng-container *ngFor="let signature of signatures; let i = index">
				<app-message *ngIf="i > 0" [signatureObject]="signature" [expanded]="false" (emitRequestCancelled)="requestCancelled($event)"></app-message>
			</ng-container>
		</ng-container>

		<div class="group" *ngIf="!initialLoad && !requestSent && !errorResponse && (signatures.length == 0 || showCreateNewRequest)">
			<!-- FILE SELECTOR -->
			<app-file (emitLoadingGeneratedFile)="setLoadingGeneratedFile($event)" (emitUploadedDoc)="setUploadedDoc($event)" (emitTemplates)="setTemplates($event)" (emitSelectedTemplate)="setSelectedTemplate($event)" (emitUseGeneratedFile)="setUseGeneratedFile($event)"></app-file>

			<!-- ATTACHMENTS -->
			<span class="container-subtitle" *ngIf="loadingAttachments">Attachments</span>
			<div class="group-container attachments" *ngIf="loadingAttachments">
				<div class="message loading">
					<i class="fas fa-spinner fa-spin"></i> <span>Loading attachments...</span>
				</div>
			</div>
			<span class="container-subtitle" *ngIf="!loadingAttachments && attachments.length > 0">Attachments</span>
			<div class="group-container attachments" [ngClass]="{'success': calculateAttachmentsCount() > 0 }" *ngIf="!loadingAttachments && attachments.length > 0">
				<!-- <div class="message">
					<div class="group-title"><i class="fas fa-paperclip"></i>
						<span>{{ calculateAttachmentsCount() }} file<span *ngIf="calculateAttachmentsCount() !== 1">s</span> selected</span>
					</div>
				</div> -->
				<div class="data">
					<div class="filename-container" *ngFor="let attachment of attachments">
						<div class="switch-column">
							<div class="switch">
								<input [title]="attachment.title" disabled="{{ attachment.disabled }}" [id]="'file_' + attachment.id" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="attachment.checked" [ngModelOptions]="{standalone: true}">
								<label [title]="attachment.title" [ngClass]="{'disabled': attachment.disabled }" [for]="'file_' + attachment.id" class="switch-label">Switch</label>
							</div>
						</div>
						<div class="filename-column" title="{{ attachment.filename ? attachment.filename : attachment.name }}">{{ attachment.filename ? attachment.filename : attachment.name }}</div>
					</div>
				</div>
			</div>

			<!-- SIGNERS LOADING ICON
			<div class="signers-loading-container" *ngIf="loadingGeneratedFile">
				<div class="contract-signer-loading">
					<i class="fas fa-spinner fa-spin"></i>
				</div>
			</div>-->

			<!-- REQUEST TEMPLATE -->
			<span class="container-subtitle" *ngIf="contextService.clientDetailProcore.enableDropboxSignTemplateOverlays && ((!selectedTemplate || selectedTemplate == '') || (selectedTemplate && selectedTemplate !== ''))">Request Template</span>
			<div class="request-template-container" *ngIf="contextService.clientDetailProcore.enableDropboxSignTemplateOverlays && ((!selectedTemplate || selectedTemplate == '') || (selectedTemplate && selectedTemplate !== ''))" [ngClass]="{'error': !loadingContractSigner && form.getRawValue()['signersList'].length == 0, 'warning': (form.getRawValue()['signersList'].length > 0 && !form.get('signersList').valid) || (calculateCCsCount() > 0 && !validateCCs()), 'success': (form.getRawValue()['signersList'].length > 0 && form.get('signersList').valid) && ((calculateCCsCount() > 0 && validateCCs()) || calculateCCsCount() == 0) }">
				<!-- SELECT CONTAINER -->
				<div class="select-container" *ngIf="!loadingContractSigner && !loadingGeneratedFile && (!selectedTemplate || selectedTemplate == '')" [ngClass]="{'selected': selectedTemplateOverlay }">
					<div class="message expandable" [ngClass]="{'expanded': showTemplateOverlaysExpanded}" (click)="showTemplateOverlaysExpanded = !showTemplateOverlaysExpanded">
						<em *ngIf="!showTemplateOverlaysExpanded" class="fas fa-angle-down expand"></em>
						<em *ngIf="showTemplateOverlaysExpanded" class="fas fa-angle-up expand"></em>
						<div *ngIf="!selectedTemplateOverlay" class="group-title"><i class="fas fa-file-contract"></i><span>Select Request Template</span></div>
						<div *ngIf="selectedTemplateOverlay" class="group-title" [title]="selectedTemplateOverlay.title"><i class="fas fa-file-contract"></i><span>{{ selectedTemplateOverlay.title }}</span></div>
					</div>
					<div class="data" [ngClass]="{'hidden': !showTemplateOverlaysExpanded}">
						<div class="select-item top" (click)="unsetSelectedTemplateOverlay()">
							<span><i class="fas fa-times"></i></span>
							<span class="text">No request template</span>
						</div>
						<div class="select-item" *ngFor="let template of templates" (click)="setSelectedTemplateOverlay(template)">
							<span><i class="fas fa-file-contract"></i> </span>
							<span class="text" [title]="template?.title">{{ template.title }}</span>
						</div>
					</div>
				</div>
				<div class="select-container disabled" *ngIf="loadingContractSigner || loadingGeneratedFile || (selectedTemplate && selectedTemplate !== '')">
					<div class="message">
						<em class="fas fa-angle-down expand"></em>
						<div class="group-title"><i class="fas fa-file-contract"></i><span>Select Request Template</span></div>
					</div>
				</div>

				<!-- SIGNERS -->
				<div class="signers-padding-container" *ngIf="loadingContractSigner || loadingGeneratedFile">
					<div class="contract-signer-loading">
						<i class="fas fa-spinner fa-spin"></i>
					</div>
				</div>
				<div class="signers-padding-container" *ngIf="!loadingContractSigner">
					<span class="container-subtitle">Signers</span>
					<div class="group-container" [ngClass]="{'error': !loadingContractSigner && form.getRawValue()['signersList'].length == 0,'warning': form.getRawValue()['signersList'].length > 0 && !form.get('signersList').valid, 'success': form.getRawValue()['signersList'].length > 0 && form.get('signersList').valid}">
						<!-- <div class="message">
							<div class="group-title"><i class="fas fa-user"></i><span>{{ calculateSignersCount() }} signer<span *ngIf="calculateSignersCount() !== 1">s</span> added</span></div>
						</div> -->
						<!-- <div class="data" *ngIf="loadingContractSigner">
							<div class="contract-signer-loading">
								<i class="fas fa-spinner fa-spin"></i>
							</div>
						</div> -->
						<div class="data">
							<ng-container formArrayName="signersList">
								<ng-container *ngFor="let signer of form.getRawValue()['signersList']; trackBy: trackSigners; let i = index">
									<ng-container [formGroupName]="i">
										<div class="signers-container" [ngClass]="{'template': selectedTemplate || selectedTemplateOverlay}">
											<div class="number-container">
												<div class="first"><em *ngIf="form.getRawValue()['signersList'].length > 1 && i !== 0" class="fas fa-chevron-up" (click)="moveSignerUp(i)" title="Move Up"></em></div>
												<div class="middle">
													<div class="number">{{ i + 1 }}</div>
												</div>
												<div class="last"><em *ngIf="form.getRawValue()['signersList'].length > 1 && i !== form.getRawValue()['signersList'].length - 1" class="fas fa-chevron-down" (click)="moveSignerDown(i)" title="Move Down"></em></div>
											</div>
											<div class="form-data-container">
												<div class="role-container">
													<span *ngIf="!selectedTemplate && !selectedTemplateOverlay">Signer {{ i + 1 }}</span>
													<span *ngIf="selectedTemplate || selectedTemplateOverlay">{{ signer.role }}</span>
													<span *ngIf="!selectedTemplate && !selectedTemplateOverlay" class="right"><i class="fas fa-times" (click)="removeSigner(i)"></i></span>
												</div>
												<div class="field-container">
													<div class="form-row">
														<ng-select placeholder="Signer name" [addTag]="true" [items]="internalUsers" formControlName="signerEmail" id="signerName" bindLabel="name" bindValue="email" [clearable]="true" (change)="updateSigner($event, i)"></ng-select>
													</div>
													<div class="form-row">
														<input type="text" placeholder="Signer e-mail" formControlName="signerEmail" id="signerEmail" class="form-control">
													</div>
												</div>
											</div>
										</div>
									</ng-container>
								</ng-container>
							</ng-container>

							<!-- <button *ngIf="!selectedTemplate && !selectedTemplateOverlay" type="button" class="btn btn-primary btn-md" (click)="addSigner('')"><em class="fas fa-user"></em> Add Signer</button> -->
							<div *ngIf="!selectedTemplate && !selectedTemplateOverlay" class="add-signer-link"><a (click)="addSigner('')"><i class="fas fa-plus"></i> Add signer</a></div>

						</div>
					</div>

					<!-- CCs -->
					<span class="container-subtitle">CC Recipients</span>
					<div class="group-container" [ngClass]="{'warning': calculateCCsCount() > 0 && !validateCCs(), 'success': calculateCCsCount() > 0 && validateCCs()}">
						<!-- <div class="message">
							<div class="group-title"><i class="fas fa-user"></i><span>{{ calculateCCsCount() }} CC recipient<span *ngIf="calculateCCsCount() !== 1">s</span> added</span></div>
						</div> -->
						<div class="data">
							<ng-container *ngFor="let cc of ccList; let i = index">
								<div class="cc-field">
									<input type="email" placeholder="CC e-mail" id="ccEmail" class="form-control" value="{{ cc.email }}" (blur)="updateCC($event, i)">
									<i class="fas fa-times" (click)="removeCC(i)"></i>
								</div>
							</ng-container>
							<div class="add-signer-link"><a (click)="addCC()"><i class="fas fa-plus"></i> Add cc recipient</a></div>
						</div>
					</div>
				</div>
			</div>

			<!-- NO REQUEST TEMPLATES -->
			<ng-container *ngIf="!contextService.clientDetailProcore.enableDropboxSignTemplateOverlays">
				<!-- SIGNERS -->
				<span class="container-subtitle">Signers</span>
				<div class="group-container" [ngClass]="{'error': !loadingContractSigner && form.getRawValue()['signersList'].length == 0,'warning': form.getRawValue()['signersList'].length > 0 && !form.get('signersList').valid, 'success': form.getRawValue()['signersList'].length > 0 && form.get('signersList').valid}">
					<div class="message">
						<div class="group-title"><i class="fas fa-user"></i><span>{{ calculateSignersCount() }} signer<span *ngIf="calculateSignersCount() !== 1">s</span> added</span></div>
					</div>
					<div class="data" *ngIf="loadingGeneratedFile || loadingContractSigner">
						<div class="contract-signer-loading">
							<i class="fas fa-spinner fa-spin"></i>
						</div>
					</div>
					<div class="data" *ngIf="!loadingContractSigner">
						<ng-container formArrayName="signersList">
							<ng-container *ngFor="let signer of form.getRawValue()['signersList']; trackBy: trackSigners; let i = index">
								<ng-container [formGroupName]="i">
									<div class="signers-container" [ngClass]="{'template': selectedTemplate || selectedTemplateOverlay}">
										<div class="number-container">
											<div class="first"><em *ngIf="form.getRawValue()['signersList'].length > 1 && i !== 0" class="fas fa-chevron-up" (click)="moveSignerUp(i)" title="Move Up"></em></div>
											<div class="middle">
												<div class="number">{{ i + 1 }}</div>
											</div>
											<div class="last"><em *ngIf="form.getRawValue()['signersList'].length > 1 && i !== form.getRawValue()['signersList'].length - 1" class="fas fa-chevron-down" (click)="moveSignerDown(i)" title="Move Down"></em></div>
										</div>
										<div class="form-data-container">
											<div class="role-container">
												<span *ngIf="!selectedTemplate && !selectedTemplateOverlay">Signer {{ i + 1 }}</span>
												<span *ngIf="selectedTemplate || selectedTemplateOverlay">{{ signer.role }}</span>
												<span *ngIf="!selectedTemplate && !selectedTemplateOverlay" class="right"><i class="fas fa-times" (click)="removeSigner(i)"></i></span>
											</div>
											<div class="field-container">
												<div class="form-row">
													<ng-select placeholder="Signer name" [addTag]="true" [items]="internalUsers" formControlName="signerEmail" id="signerName" bindLabel="name" bindValue="email" [clearable]="true" (change)="updateSigner($event, i)"></ng-select>
												</div>
												<div class="form-row">
													<input type="text" placeholder="Signer e-mail" formControlName="signerEmail" id="signerEmail" class="form-control">
												</div>
											</div>
										</div>
									</div>
								</ng-container>
							</ng-container>
						</ng-container>

						<!-- <button *ngIf="!selectedTemplate && !selectedTemplateOverlay" type="button" class="btn btn-primary btn-md" (click)="addSigner('')"><em class="fas fa-user"></em> Add Signer</button> -->
						<div *ngIf="!selectedTemplate && !selectedTemplateOverlay" class="add-signer-link"><a (click)="addSigner('')"><i class="fas fa-plus"></i> Add signer</a></div>

					</div>
				</div>

				<!-- CCs -->
				<span class="container-subtitle">CCs</span>
				<div class="group-container" [ngClass]="{'warning': calculateCCsCount() > 0 && !validateCCs(), 'success': calculateCCsCount() > 0 && validateCCs()}">
					<div class="message">
						<div class="group-title"><i class="fas fa-user"></i><span>{{ calculateCCsCount() }} CC recipient<span *ngIf="calculateCCsCount() !== 1">s</span> added</span></div>
					</div>
					<div class="data">
						<ng-container *ngFor="let cc of ccList; let i = index">
							<div class="cc-field">
								<input type="email" placeholder="CC e-mail" id="ccEmail" class="form-control" value="{{ cc.email }}" (blur)="updateCC($event, i)">
								<i class="fas fa-times" (click)="removeCC(i)"></i>
							</div>
						</ng-container>
						<div class="add-signer-link"><a (click)="addCC()"><i class="fas fa-plus"></i> Add cc recipient</a></div>
					</div>
				</div>
			</ng-container>

			<!-- OPTIONS -->
			<span class="container-subtitle" *ngIf="contextService.clientDetailProcore.allowDeclineRequest || contextService.clientDetailProcore.allowSignerReassignment || contextService.clientDetailProcore.allowExpirationDate || projectConfigs.allowDefaultLocationOverride">Options</span>
			<div class="group-container options" [ngClass]="{'success': calculateOptionsCount() > 0 }" *ngIf="contextService.clientDetailProcore.allowDeclineRequest || contextService.clientDetailProcore.allowSignerReassignment || contextService.clientDetailProcore.allowExpirationDate || projectConfigs.allowDefaultLocationOverride">
				<!-- <div class="message">
					<div class="group-title"><i class="fas fa-sliders-h"></i><span>{{ calculateOptionsCount() }} option<span *ngIf="calculateOptionsCount() !== 1">s</span> selected</span></div>
				</div> -->
				<div class="data">
					<div class="switch-column" *ngIf="contextService.clientDetailProcore.allowDeclineRequest">
						<div class="switch">
							<input id="allowDecline" formControlName="allowDecline" type="checkbox" class="switch-input client-checkbox">
							<label for="allowDecline" class="switch-label">Switch</label>
						</div>
						<div class="filename-column">Allow the signer to decline the request</div>
					</div>
					<div class="switch-column" *ngIf="contextService.clientDetailProcore.allowSignerReassignment">
						<div class="switch">
							<input id="allowReassign" formControlName="allowReassign" type="checkbox" class="switch-input client-checkbox">
							<label for="allowReassign" class="switch-label">Switch</label>
						</div>
						<div class="filename-column">Allow the signer to re-assign the request</div>
					</div>
					<div class="switch-row" *ngIf="contextService.clientDetailProcore.allowExpirationDate">
						<label>Set an expiration date for the request:</label>
						<input type="date" [min]="getExpirationMinDate()" [max]="getExpirationMaxDate()" formControlName="expirationDate" id="expirationDate" class="form-control">
					</div>
					<div class="switch-row" *ngIf="projectConfigs.allowDefaultLocationOverride">
						<label>Set the executed document storage location:</label>
						<select id="fileLocation" formControlName="fileLocation">
							<option value="default">{{ getDefaultFileLocationLabel() }}</option>
							<option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</option>
						</select>
					</div>
				</div>
			</div>
		</div>

		<!-- <ng-container *ngIf="isSubmittal">
			<div class="group" *ngIf="!loading && !signature && !isSubmittalManager">
				<div class="message"><em class="fas fa-info-circle"></em> The signature request must be made by the Submittal Manager</div>
			</div>
			<div class="group" *ngIf="!loading && signature && !isSigner">
				<div class="message"><em class="fas fa-info-circle"></em> Your signature is not required for this Submittal</div>
			</div>
			<div class="group" *ngIf="!loading && signature && isSigner && !hasBallInCourt">
				<div class="message"><em class="fas fa-info-circle"></em> It is not your turn to sign the Submittal</div>
			</div>
		</ng-container>
		<ng-container *ngIf="isRfi">
			<div class="group" *ngIf="!loading && !signature && !isRfiManager">
				<div class="message"><em class="fas fa-info-circle"></em> The signature request must be made by the RFI Manager</div>
			</div>
		</ng-container> -->

		<div class="error-container" *ngIf="errorResponse && !requestSent">
			<div class="error-title" [innerHTML]="errorResponse"></div>
			<div class="error-back"><a (click)="errorResponse = ''">Go back</a> or <a (click)="twoZeroFourRetries = 0; submit()">retry the request</a></div>
		</div>

		<ng-container *ngIf="!initialLoad && !requestSent && !errorResponse">
			<div class="btn-launch-container">
				<ng-container *ngIf="!isSubmittal">
					<button *ngIf="signatures.length > 1 && !showAllRequests && !showCreateNewRequest" type="button" class="btn btn-primary btn-md" (click)="showAllRequests = true">View {{ signatures.length - 1 }} Previous Requests</button>
					<button *ngIf="signatures.length > 1 && showAllRequests" type="button" class="btn btn-primary btn-md" (click)="showAllRequests = false">Hide {{ signatures.length - 1 }} Previous Requests</button>

					<!-- {{ signatures.length > 0 }} - {{ !showAllRequests }} - {{ !showCreateNewRequest }} - {{ (!isRfi || isRfiManager) }} - {{ (signatures[0].clientSignature.status === 'COMPLETED' || signatures[0].clientSignature.status === 'CANCELLED' || signatureRequestExpired) }} -->
					<button *ngIf="signatures.length > 0 && !showAllRequests && !showCreateNewRequest && (!isRfi || isRfiManager) && (signatures[0].clientSignature.status === 'COMPLETED' || signatures[0].clientSignature.status === 'CANCELLED' || signatureRequestExpired)" type="button" class="btn btn-primary btn-md" (click)="showCreateNewRequest = true; showCancelAndEditRequest = false;">Create New Request</button>
					<button *ngIf="signatures.length > 0 && !showAllRequests && !showCreateNewRequest && (!isRfi || isRfiManager) && (signatures[0].clientSignature.status !== 'COMPLETED' && signatures[0].clientSignature.status !== 'CANCELLED' && !signatureRequestExpired) && (signatures[0].clientSignature.requestedUser == contextService.procoreUserInfo.email || contextService.clientDetailProcore.dropboxSignAccountType == 'API' || contextService.signatureCount.dropboxSignRoleCode == 'a' || (contextService.clientDetailProcore.anyUserCanCancel && contextService.signatureCount.dropboxSignApiKeyExists))" type="button" class="btn btn-primary btn-md" (click)="showCreateNewRequest = true; showCancelAndEditRequest = true;">Cancel and Edit Request</button>
					<button *ngIf="signatures.length > 0 && !showAllRequests && showCreateNewRequest && (!isRfi || isRfiManager)" type="button" class="btn btn-primary btn-md" (click)="showCreateNewRequest = false">Cancel New Request</button>
					<button *ngIf="signatures.length == 0 && !showAllRequests && !showCreateNewRequest && (!isRfi || isRfiManager)" type="button" class="btn btn-primary btn-md launch-dropbox-sign" [disabled]="loadingGeneratedFile || !form.valid || (!uploadedDoc && !useGeneratedFile && !selectedTemplate) || form.getRawValue()['signersList'].length === 0 || (contextService.signatureCount?.signatures.used >= contextService.signatureCount?.signatures.total) || (ccList.length > 0 && !validateCCs())" (click)="twoZeroFourRetries = 0; submit()"><em class="fas fa-signature"></em> Launch Dropbox Sign</button>
					<!-- <button *ngIf="signatures.length > 0 && !signatureRequestExpired && signatures[0].clientSignature.status !== 'CANCELLED' && signatures[0].clientSignature.status !== 'COMPLETED' && (!isRfi || isRfiManager) && !showCreateNewRequest" type="button" class="btn btn-primary btn-md cancel-request" (click)="cancel()">Cancel Request</button> -->
					<!-- <button *ngIf="signatures.length > 0 && signatures[0].clientSignature.status !== 'CANCELLED' && signatures[0].clientSignature.status !== 'COMPLETED' && (!isRfi || isRfiManager) && showCreateNewRequest" type="button" class="btn btn-primary btn-md cancel-edit-request" (click)="showCreateNewRequest = false">Cancel Edit Request</button> -->

					<!-- <button *ngIf="signatures.length > 0 && !signatureRequestExpired && !showCreateNewRequest && (!isRfi || isRfiManager) && signatures[0].clientSignature.status === 'REQUESTED'" type="button" class="btn btn-primary btn-md send-reminder" (click)="sendReminder()">Send Reminder</button> -->
					<!-- <button *ngIf="signatures.length > 0 && signatures[0].clientSignature.status !== 'COMPLETED' && signatures[0].clientSignature.status !== 'CANCELLED' && showCreateNewRequest && (!isRfi || isRfiManager)" type="button" class="btn btn-primary btn-md resend-request" [disabled]="loadingGeneratedFile || !form.valid || (!uploadedDoc && !useGeneratedFile && !selectedTemplate) || form.getRawValue()['signersList'].length === 0" (click)="cancelAndResend()"><em class="fas fa-signature"></em> Launch Dropbox Sign</button> -->
					<!-- <button *ngIf="signatures.length > 0 && signatures[0].clientSignature.status === 'CANCELLED' && !showAllRequests && !showCreateNewRequest && (!isRfi || isRfiManager)" type="button" class="btn btn-primary btn-md send-new-request wide" [disabled]="loadingGeneratedFile || !form.valid || (!uploadedDoc && !useGeneratedFile && !selectedTemplate) || form.getRawValue()['signersList'].length === 0" (click)="submit()"><em class="fas fa-signature"></em> Launch Dropbox Sign</button> -->
					<!-- <button *ngIf="signatures.length > 0 && signatures[0].clientSignature.status === 'COMPLETED' && showCreateNewRequest && (!isRfi || isRfiManager)" type="button" class="btn btn-primary btn-md cancel-new-request" (click)="showCreateNewRequest = false">Cancel New Request</button> -->
					<!-- <button *ngIf="signatures.length > 0 && signatures[0].clientSignature.status === 'COMPLETED' && !showAllRequests && !showCreateNewRequest && (!isRfi || isRfiManager)" type="button" class="btn btn-primary btn-md send-new-request right" [disabled]="loadingGeneratedFile || !form.valid || (!uploadedDoc && !useGeneratedFile && !selectedTemplate) || form.getRawValue()['signersList'].length === 0" (click)="submit()"><em class="fas fa-signature"></em> Launch Dropbox Sign</button> -->
				</ng-container>
				<!-- <ng-container *ngIf="isSubmittal">
					<button *ngIf="isSubmittalManager && (!signature || (signature && signatures[0].clientSignature.status === 'COMPLETED' && showCreateNewRequest))" type="button" class="btn btn-primary btn-md" [disabled]="loadingGeneratedFile || !form.valid || (!uploadedDoc && !useGeneratedFile && !selectedTemplate) || form.getRawValue()['signersList'].length === 0" (click)="submitSignatureRequest()"><em class="fas fa-signature"></em> Send to Dropbox Sign</button>
					<button *ngIf="hasBallInCourt" type="button" class="btn btn-primary btn-md" (click)="signSignatureRequest()">Sign Request</button>
				</ng-container> -->
			</div>
			<button *ngIf="showCreateNewRequest && !showCancelAndEditRequest" type="button" class="btn btn-primary btn-md launch-sign" [disabled]="loadingGeneratedFile || !form.valid || (!uploadedDoc && !useGeneratedFile && !selectedTemplate) || form.getRawValue()['signersList'].length == 0 || (contextService.signatureCount?.signatures.used >= contextService.signatureCount?.signatures.total) || (ccList.length > 0 && !validateCCs())" (click)="twoZeroFourRetries = 0; submit()"><em class="fas fa-signature"></em> Launch Dropbox Sign</button>
			<button *ngIf="showCreateNewRequest && showCancelAndEditRequest" type="button" class="btn btn-primary btn-md launch-sign" [disabled]="loadingGeneratedFile || !form.valid || (!uploadedDoc && !useGeneratedFile && !selectedTemplate) || form.getRawValue()['signersList'].length == 0 || (contextService.signatureCount?.signatures.used >= contextService.signatureCount?.signatures.total) || (ccList.length > 0 && !validateCCs())" (click)="submitCancelAndResend()"><em class="fas fa-signature"></em> Launch Dropbox Sign</button>
		</ng-container>

		<!-- <ng-container *ngIf="signatures.length > 0 && !requestSent">
			<div class="previous-link-container"><a (click)="showPrevious = !showPrevious">{{ showPrevious ? 'Hide Request History' : 'View Request History'}}</a></div>
			<div class="previous-data-container" *ngIf="showPrevious">
				<ng-container *ngFor="let signature of signatures">
					<div class="group" *ngIf="showPrevious && signatures[0].clientSignature.status === 'REQUESTED'">
						<div class="request-data">
							<div class="left">Sent</div>
							<div class="right">{{ signatures[0].clientSignature.signatureRequestDate | date:'MMM d, y' }}</div>
						</div>
						<div class="request-data">
							<div class="left">Status</div>
							<div class="right">{{ signatures[0].clientSignature.status }}</div>
						</div>
						<div class="request-data" *ngIf="signatures[0].clientSignature.signatureExpirationDate">
							<div class="left">Expiration Date</div>
							<div class="right">{{ signatures[0].clientSignature.signatureExpirationDate | date:'MMM d, y' }}</div>
						</div>
						<ng-container *ngIf="signatures[0].signatures">
							<div class="request-data" *ngFor="let signatory of signatures[0].signatures; let j = index">
								<div class="left">Signer {{ j + 1 }}</div>
								<div class="right" [title]="signatory.signer_email_address">{{ signatory.signer_name }}</div>
							</div>
						</ng-container>
					</div>

					<div class="group" *ngIf="showPrevious && signatures[0].clientSignature.status === 'CANCELLED'">
						<div class="request-data">
							<div class="left">Sent</div>
							<div class="right">{{ signatures[0].clientSignature.signatureRequestDate | date:'MMM d, y' }}</div>
						</div>
						<div class="request-data">
							<div class="left">Status</div>
							<div class="right">{{ signatures[0].clientSignature.status }}</div>
						</div>
						<ng-container *ngIf="signatures[0].signatures">
							<div class="request-data" *ngFor="let signatory of signatures[0].signatures; let j = index">
								<div class="left">Signer {{ j + 1 }}</div>
								<div class="right" [title]="signatory.signer_email_address">{{ signatory.signer_name }}</div>
							</div>
						</ng-container>
					</div>

					<div class="group" *ngIf="showPrevious && signatures[0].clientSignature.status === 'COMPLETED'">
						<div class="request-data">
							<div class="left">Sent</div>
							<div class="right">{{ signatures[0].clientSignature.signatureRequestDate | date:'MMM d, y' }}</div>
						</div>
						<div class="request-data">
							<div class="left">Completed</div>
							<div class="right">{{ signatures[0].clientSignature.signatureCompleteDate | date:'MMM d, y' }}</div>
						</div>
						<div class="request-data">
							<div class="left">Status</div>
							<div class="right">
								<a *ngIf="signatures[0].clientSignature.status === 'COMPLETED'" href="javascript:" (click)="downloadFile(signatures[0].clientSignature)">{{ signatures[0].clientSignature.status }}</a>
							</div>
						</div>
						<ng-container *ngIf="signatures[0].signatures">
							<div class="request-data" *ngFor="let signatory of signatures[0].signatures; let j = index">
								<div class="left">Signer {{ j + 1 }}</div>
								<div class="right" [title]="signatory.signer_email_address">{{ signatory.signer_name }}</div>
							</div>
						</ng-container>
					</div>
				</ng-container>
			</div>
		</ng-container> -->

		<div *ngIf="requestSent && !isSubmittal && !isRfi" class="launched-message">
			<div>Dropbox Sign has been launched. Wait a few seconds to reload this panel after the signature request has been sent.</div>
			<div class="reinit-container"><i class="fas fa-sync-alt" (click)="reInit()"></i></div>
		</div>
		<div *ngIf="requestSent && (isSubmittal || isRfi)">
			<div>The Signature Request has been created. Reload this panel to track its status.</div>
			<div class="reinit-container"><i class="fas fa-sync-alt" (click)="reInit()"></i></div>
		</div>
		<!-- <div *ngIf="authError">
			Your browser is potentially blocking popups. Please turn off any popup blockers and refresh the page.
		</div> -->
	</form>
</div>

<app-configure *ngIf="showConfigure && !loadingUserLogout" (emitExit)="exitConfiguration($event)" [folders]="folders" [templates]="templates"></app-configure>

<app-configure-user *ngIf="showConfigureUser && !loadingUserLogout" (emitExit)="exitConfigurationUser($event)"></app-configure-user>